<template>
    <div>
        <top-bar-secondary>
            <template v-slot:module-action-left>
                <b-navbar-nav>
                    <b-nav-item-dropdown
                        v-if="
                            _hasAccess('schedule.access') && !isEnhancedLayout
                        "
                    >
                        <template slot="button-content">
                            <i class="famfamfam-silk clock"></i>
                            Appointments
                        </template>
                        <b-dropdown-item to="/schedule/appointment">
                            <i class="famfamfam-silk date"></i>View Appointments
                        </b-dropdown-item>
                        <b-dropdown-item
                            @click.prevent="exportAppointment(0)"
                            v-if="_hasAccess('schedule.export')"
                            href="#0"
                        >
                            <i class="famfamfam-silk printer"></i>Print
                            Appointments
                        </b-dropdown-item>
                        <b-dropdown-item
                            @click.prevent="exportAppointment(1)"
                            v-if="_hasAccess('schedule.export')"
                            href="#0"
                        >
                            <i class="famfamfam-silk email"></i>Email
                            Appointments
                        </b-dropdown-item>
                    </b-nav-item-dropdown>
                    <b-nav-item
                        to="/schedule/inbox"
                        v-if="
                            _isExtensionEnabled('2_WAY_MESSAGING') &&
                            _hasAccess('schedule.conversation.view')
                        "
                    >
                        <conversation-icon />
                    </b-nav-item>
                    <b-nav-item to="/schedule/census" v-if="!isEnhancedLayout">
                        <i class="cus-compass"></i>Census
                    </b-nav-item>

                    <b-nav-item-dropdown
                        v-if="
                            _isExtensionEnabled('TREATMENT_BOARD') &&
                            _hasAccess('schedule.treatmentboard.view') &&
                            !isEnhancedLayout
                        "
                    >
                        <template slot="button-content">
                            <i class="cus-stethoscope"></i>
                            Treatment
                        </template>
                        <b-dropdown-item to="/schedule/treatment">
                            <i class="cus-stethoscope"></i>View Board
                        </b-dropdown-item>
                        <div class="dropdown-divider"></div>
                        <b-dropdown-item :to="{ name: 'treatment.admit' }">
                            <i class="famfamfam-silk add"></i>Admit Patient
                        </b-dropdown-item>
                        <b-dropdown-item
                            v-if="_hasAccess('schedule.treatmentboard.create')"
                            :to="{ name: 'treatment.activity' }"
                        >
                            <i class="famfamfam-silk add"></i>New Activity
                        </b-dropdown-item>
                        <b-dropdown-item
                            v-if="_hasAccess('schedule.treatmentboard.create')"
                            :to="{ name: 'treatment.bundle' }"
                        >
                            <i class="famfamfam-silk add"></i>New Bundle
                        </b-dropdown-item>
                    </b-nav-item-dropdown>
                    <b-nav-item
                        @click.prevent="
                            $router.push({
                                name: 'report_detail',
                                params: {
                                    id: 'reminder',
                                    ref: 'schedule'
                                }
                            })
                        "
                        href="/view/report/reminder"
                        v-if="
                            _hasAccess('schedule.reminder.access') &&
                            !isEnhancedLayout
                        "
                    >
                        <i class="famfamfam-silk clock"></i>Reminders
                    </b-nav-item>

                    <b-nav-item-dropdown
                        v-if="isBoardingEnable && !isEnhancedLayout"
                    >
                        <template slot="button-content">
                            <i class="famfamfam-silk house"></i>
                            Boarding
                        </template>
                        <b-dropdown-item to="/schedule/boarding/dashboard">
                            <i class="famfamfam-silk image"></i>View Dashboard
                        </b-dropdown-item>
                        <b-dropdown-item to="/schedule/boarding/reservations">
                            <i class="famfamfam-silk house"></i>View
                            Reservations
                        </b-dropdown-item>
                        <div
                            class="dropdown-divider"
                            v-if="isShowDividerPrintBoarding"
                        ></div>
                        <b-dropdown-item
                            @click.prevent="boardingPrint"
                            v-if="
                                _hasAccess(
                                    'schedule.boarding.print.reservation.list'
                                )
                            "
                            href
                        >
                            <i class="famfamfam-silk printer"></i>Print
                            Reservation List
                        </b-dropdown-item>
                        <b-dropdown-item
                            @click.prevent="boardingEmail"
                            v-if="
                                _hasAccess(
                                    'schedule.boarding.email.reservation.list'
                                )
                            "
                            href
                        >
                            <i class="famfamfam-silk email"></i>Email
                            Reservation List
                        </b-dropdown-item>
                        <div
                            class="dropdown-divider"
                            v-if="isShowBoardingFormMenu"
                        ></div>
                        <b-dropdown-item
                            @click.prevent="boardingForm"
                            v-if="isShowBoardingFormMenu"
                            href
                        >
                            <i class="famfamfam-silk printer"></i>Print Boarding
                            Forms
                        </b-dropdown-item>
                        <div
                            class="dropdown-divider"
                            v-if="_hasAccess('schedule.boarding.create')"
                        />
                        <b-dropdown-item
                            @click.prevent="openNewReservationDialog"
                            href="#"
                            v-if="_hasAccess('schedule.boarding.create')"
                        >
                            <i class="famfamfam-silk add"></i>New Reservation
                        </b-dropdown-item>
                    </b-nav-item-dropdown>

                    <b-nav-item-dropdown
                        v-if="
                            _hasAccess('schedule.access') && !isEnhancedLayout
                        "
                    >
                        <template slot="button-content">
                            <i class="famfamfam-silk bell"></i>
                            Tasks
                        </template>
                        <b-dropdown-item to="/schedule/tasks?status=3">
                            <i class="famfamfam-silk bell"></i>Assigned to Me
                        </b-dropdown-item>
                        <b-dropdown-item to="/schedule/tasks?status=4">
                            <i class="famfamfam-silk bell"></i>Created by Me
                        </b-dropdown-item>
                        <b-dropdown-item
                            v-if="_hasAccess('schedule.task.access')"
                            to="/schedule/tasks?task_status=0"
                        >
                            <i class="famfamfam-silk bell"></i>All Open & In
                            Progress
                        </b-dropdown-item>
                        <b-dropdown-item
                            v-if="_hasAccess('schedule.task.access')"
                            to="/schedule/tasks?task_status=1"
                        >
                            <i class="famfamfam-silk bell"></i>All Completed
                        </b-dropdown-item>
                        <div class="dropdown-divider"></div>
                        <b-dropdown-item @click="$refs.modalAddNewTask.open()">
                            <i class="famfamfam-silk add"></i>New Task
                        </b-dropdown-item>
                    </b-nav-item-dropdown>
                </b-navbar-nav>
            </template>
            <template v-slot:module-action-right>
                <b-navbar-nav
                    class="ml-auto"
                    v-if="!isEnhancedLayout && isAppointment"
                >
                    <search-appointment @onselect="applySearchAppointment" />
                </b-navbar-nav>
            </template>
        </top-bar-secondary>

        <content-wrapper>
            <b-container fluid>
                <router-view ref="routerView"></router-view>
                <exportAppointment ref="exportAppointmentWindow" />
                <boardingReservation ref="boardingReservationWindow" />
                <boardingForm ref="boardingFormWindow" />
            </b-container>
        </content-wrapper>

        <modal-new-task ref="modalAddNewTask" />

        <modal-reservation
            ref="modalReservation"
            @clearblocker="boardingClearDraft"
            @save="onSaveReservation"
            :session="boardingSession"
            @shown="modalReservationShown"
        />
    </div>
</template>
<script>
import ExportAppointment from "./export-appointment.vue";
import BoardingReservation from "./boarding/reservation-list.vue";
import BoardingForm from "./boarding/print-form.vue";
import ScheduleHelper from "./helper";
import ConversationIcon from "@/module/inbox/2-way-icon";
import SearchAppointment from "./search-appointment";
import ModalNewTask from "@/components/tasks/task-update-modal";
import ModalReservation from "@/module/schedule/boarding/modal-reservation/main.vue";
import uuidv4 from "uuid/v4";
import BoardingService from "@/services/boarding.js";
import TopBarSecondary from "@/module/layout/top-bar-secondary.vue";
import ContentWrapper from "@/module/layout/content-wrapper.vue";

export default {
    components: {
        TopBarSecondary,
        ContentWrapper,
        ExportAppointment,
        BoardingForm,
        BoardingReservation,
        ConversationIcon,
        SearchAppointment,
        ModalNewTask,
        ModalReservation
    },
    mixins: [ScheduleHelper],
    data() {
        return {
            resources: {},
            isSwitchingCalendar: false,
            boardingSession: uuidv4()
        };
    },
    computed: {
        isBoardingEnable() {
            return (
                this._isExtensionEnabled("BOARDING") &&
                this._hasAccess("schedule.boarding.access")
            );
        },
        isShowBoardingFormMenu() {
            return this._hasAccess("schedule.boarding.print.boarding.form");
        },
        isShowDividerPrintBoarding() {
            if (
                this._hasAccess("schedule.boarding.print.reservation.list") ||
                this._hasAccess("schedule.boarding.email.reservation.list")
            ) {
                return true;
            }
            return false;
        },
        switch_text() {
            return this.$root.setting.schedule_view
                ? "Switch to list view"
                : "Switch to classic view";
        },
        isAppointment() {
            return this.$route.name === "appointment";
        },
        isTasks() {
            return this.$route.name === "tasks";
        },
        isEnhancedLayout() {
            return this.$store.state.isEnhancedLayout;
        },
        appointmentSearch() {
            return this.$store.state.appointmentSearch;
        }
    },
    watch: {
        appointmentSearch(newVal) {
            this.applySearchAppointment(newVal);
        }
    },
    mounted() {
        this._getStatus().then(statuses => {
            this.$store.commit(
                "status",
                statuses.map(status => ({
                    ...status,
                    icon: this.statusClass(status.id)
                }))
            );
        });
    },
    methods: {
        modalReservationShown() {
            document.body.style.cursor = "";
        },
        onSaveReservation() {
            if (this.$router.currentRoute.name === "boarding.reservations") {
                window.refreshCalendarBoarding();
            } else {
                this.$router.push({
                    name: "boarding.reservations"
                });
            }
        },
        boardingClearDraft(ids = []) {
            this.$socket.client.emit("v-broadcast-all", {
                action: "boarding:calendar:draft-remove",
                businessId: this.$root.setting.business_id,
                blockerIds: ids
            });
        },
        openNewReservationDialog() {
            document.body.style.cursor = "wait";
            this.$refs.modalReservation.openFromExternal({
                blockerId: uuidv4()
            });
        },
        async switchToCI() {
            await BoardingService.toggleNewBoarding(false);
            window.location.replace(process.env.APPS + "index.php/schedule/boarding"); // prettier-ignore
        },
        exportAppointment(exportType) {
            this.$refs.exportAppointmentWindow.open(exportType);
        },
        boardingEmail() {
            this.$refs["boardingReservationWindow"].open(true);
        },
        boardingPrint() {
            this.$refs["boardingReservationWindow"].open(false);
        },
        boardingForm() {
            this.$refs["boardingFormWindow"].open();
        },
        applySearchAppointment(result = {}) {
            if (this.$router.currentRoute.path === "/schedule/appointment") {
                let calendarView = this.$refs.routerView;

                if (calendarView.changeDayPicker) {
                    calendarView.changeDayPicker("resourceTimeGridDay", {
                        date: result.dateMoment
                    });
                }
            }
        }
    }
};
</script>
